export const SET_CLIENT_SESSION = 'SET_CLIENT_SESSION';
export const RESET_CLIENT_SESSION = 'RESET_CLIENT_SESSION';
export const SET_ENTITY_TYPES = 'SET_ENTITY_TYPES';
export const SET_COLLAPSE = 'SET_COLLAPSE';
